// extracted by mini-css-extract-plugin
export default {"tableHeadersContainer":"styles_tableHeadersContainer__JIFEp","tech":"styles_tech__aMcp+","routes":"styles_routes__mQY1B","headerText":"styles_headerText__6+Y6W"};